// material-ui
import { styled } from '@mui/material/styles';

// ==============================|| AUTHENTICATION 1 WRAPPER ||============================== //

const Wrapper = styled('div')(({ theme }) => ({
    backgroundColor: "#FFFAF5",
    minHeight: '100dvh'
}));

export default Wrapper;